import {WixSdk} from 'js-sdk-wrapper';
import {LAYOUT_DEFAULTS, LAYOUTS_LIST, LAYOUTS_VERTICAL} from './constants';
import {layoutValues} from './layout-values';

function _isFullWidth(settings) {
  return settings.booleans.isFullWidth && settings.numbers.layout === LAYOUTS_LIST;
}

function resizeWidget(settings, newDimensions) {
  const {width, height} = newDimensions;
  if (width) {
    settings.rect.width = width;
  }

  if (height) {
    settings.rect.height = height;
  }

  const isResizeAllowed = !_isFullWidth(settings) && WixSdk.Utils.getViewMode() === 'editor';
  if (height && !isResizeAllowed) {
    WixSdk.setHeight(height);
  } else if (width || height) {
    WixSdk.resizeComponent(newDimensions);
  }
}

function resizeWidgetWidth(settings, width: number) {
  settings.rect.width = width;
  WixSdk.resizeComponent({width});
}

export function resizeOnTrackStyleChange(settings, player) {
  const newDimensions = player.getDimensionsForFullTracks();

  resizeWidget(settings, newDimensions);
}

let isNextResizeEnabled = true;

export function resizeOnLayoutChange(settings, player, retry = true) {
  const currentLayout = settings.numbers.layout || LAYOUTS_VERTICAL;
  const numberTracksShown: number | undefined = (LAYOUT_DEFAULTS[currentLayout] || <any>{}).defaultNumberTracksShown;
  const currentWidth = (LAYOUT_DEFAULTS[currentLayout] || <any>{}).defaultWidth || layoutValues[currentLayout].width;
  if (currentLayout === LAYOUTS_VERTICAL && retry) {
    // for vertical layout we first want to resize a width, so the album cover
    // would get its proportion and therefore set its height
    // after that it can calculate the needed height accordingly
    resizeWidgetWidth(settings, currentWidth);
    player.onNextFrame(() => {
      resizeOnLayoutChange(settings, player, false);
      // We need to disable next-time resize, otherwise it will
      // resize with the general rules (expand to full height).
      isNextResizeEnabled = false;
    });
    return;
  }
  const minMaxDimensions = player.getDimensions({minimalTrackCount: numberTracksShown});
  const newDimensions = {
    width: getWidth(settings, minMaxDimensions, currentWidth),
    height: getHeight(settings, minMaxDimensions, numberTracksShown)
  };

  resizeWidget(settings, newDimensions);
}

export function resizeOnReInit(settings, player, forceUpdate, numberTracksShown) {
  if (!isNextResizeEnabled) {
    isNextResizeEnabled = true;
    return;
  }
  let newDimensions;

  if (forceUpdate) {
    const minMaxDimensions = player.getDimensions({minimalTrackCount: numberTracksShown});
    newDimensions = {
      width: getWidth(settings, minMaxDimensions),
      height: forceUpdate ? minMaxDimensions.maxHeight : getHeight(settings, minMaxDimensions, numberTracksShown)
    };
  } else {
    newDimensions = player.getDimensionsForFullTracks();
  }

  resizeWidget(settings, newDimensions);
}

export function getNormalizedWidth(player, settings) {
  let width;

  if (player && player.getDimensions) {
    const minMaxDimensions = player.getDimensions();
    width = getWidth(settings, minMaxDimensions);
  }

  return width || settings.rect.width;
}

function getWidth(settings, dimensions, currentWidth?: number) {
  let width = currentWidth;
  currentWidth = currentWidth || Math.round(settings.rect.width / settings.scale);

  if (dimensions.minWidth && currentWidth < dimensions.minWidth) {
    width = dimensions.minWidth;
  } else if (dimensions.maxWidth && currentWidth > dimensions.maxWidth) {
    width = dimensions.maxWidth;
  }

  return width;
}

function getHeight(settings, dimensions, numberTracksShown) {
  let height;

  const rectHeight = Math.round(settings.rect.height / settings.scale);

  if (rectHeight < dimensions.minHeight || numberTracksShown) {
    height = dimensions.minHeight;
  } else if (rectHeight > dimensions.maxHeight) {
    height = dimensions.maxHeight;
  }

  return height;
}



// WEBPACK FOOTER //
// ./widget-player/widget-resizer.ts